// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ReleaseReadinessCustomFieldGroup,
  ReleaseReadinessCustomFieldGroupFromJSON,
  ReleaseReadinessCustomFieldGroupToJSON,
} from "./";

/**
 * Coverage breakdown for a single custom field. Groups test cases by their custom field value and shows execution statistics per group. Supports both test case and test plan custom fields.
 * @export
 * @interface ReleaseReadinessCustomFieldCoverage
 */
export interface ReleaseReadinessCustomFieldCoverage {
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessCustomFieldCoverage
   */
  fieldId: number;
  /**
   *
   * @type {string}
   * @memberof ReleaseReadinessCustomFieldCoverage
   */
  fieldLabel: string;
  /**
   *
   * @type {string}
   * @memberof ReleaseReadinessCustomFieldCoverage
   */
  fieldType: ReleaseReadinessCustomFieldCoverageFieldTypeEnum;
  /**
   * Whether this is a test case or test plan custom field
   * @type {string}
   * @memberof ReleaseReadinessCustomFieldCoverage
   */
  entity?: ReleaseReadinessCustomFieldCoverageEntityEnum;
  /**
   *
   * @type {Array<ReleaseReadinessCustomFieldGroup>}
   * @memberof ReleaseReadinessCustomFieldCoverage
   */
  groups: Array<ReleaseReadinessCustomFieldGroup>;
}

export function ReleaseReadinessCustomFieldCoverageFromJSON(
  json: any
): ReleaseReadinessCustomFieldCoverage {
  return {
    fieldId: json["field_id"],
    fieldLabel: json["field_label"],
    fieldType: json["field_type"],
    entity: !exists(json, "entity") ? undefined : json["entity"],
    groups: (json["groups"] as Array<any>).map(
      ReleaseReadinessCustomFieldGroupFromJSON
    ),
  };
}

export function ReleaseReadinessCustomFieldCoverageToJSON(
  value?: ReleaseReadinessCustomFieldCoverage
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    field_id: value.fieldId,
    field_label: value.fieldLabel,
    field_type: value.fieldType,
    entity: value.entity,
    groups: (value.groups as Array<any>).map(
      ReleaseReadinessCustomFieldGroupToJSON
    ),
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ReleaseReadinessCustomFieldCoverageFieldTypeEnum {
  Dropdown = "dropdown",
  MultipleSelect = "multipleSelect",
  Date = "date",
  Number = "number",
  User = "user",
}
/**
 * @export
 * @enum {string}
 */
export enum ReleaseReadinessCustomFieldCoverageEntityEnum {
  TestCase = "TestCase",
  TestPlan = "TestPlan",
}
